import React from 'react';
import './Skills.css';
import Zoom from 'react-reveal/Zoom';

const Skills = () => {
        return (
            <>
            <Zoom>
            <h1 className='text-center pt-16 text-2xl'>Skills</h1>
            <ul id="skill">
	<li><span className="bar graphic-design"></span><h3>Html // Css</h3></li>
	<li><span className="bar html-css"></span><h3>Javascript</h3></li>
	<li><span className="bar jquery"></span><h3>jQuery // MoTools</h3></li>
	<li><span className="bar wordpress"></span><h3>Reactjs // Nextjs // Gatsbyjs</h3></li>
    <li><span className="bar sql"></span><h3>SQL // NON-SQL</h3></li>
    <li><span className="bar tail"></span><h3>Tailwind // Bootstrap</h3></li>
    <li><span className="bar c"></span><h3>C++</h3></li>
</ul>
</Zoom>
            </>
        );
    
}

export default Skills;